//@flow
import { combineReducers } from 'redux'
import {simpleReducer} from './reducerHelpers'

export default combineReducers({
  loggedIn: simpleReducer({
    'LOG_IN': true,
    'LOG_OUT': false,
    'default': false
  }),
  adminMode: simpleReducer({
    'ENTER_ADMIN_MODE': true,
    'LOG_OUT': false,
    'default': false
  })
  // currentUser: simpleReducer({
  //   'LOG_IN': 'PAYLOAD',
  //   'LOG_OUT': null,
  //   'default': null
  // })
})



// WEBPACK FOOTER //
// ./src/reducers/auth.js